import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { SendMessageDocument } from 'src/generated/graphql';

// Mock for SendMessage query used during authentication in FederatedAuth.tsx
export const sendMessageMock = (async () => {
  return {
    request: {
      query: SendMessageDocument,
      variables: MATCH_ANY_PARAMETERS,
    },
    result: {
      data: {
        sendMessage: {
          __typename: 'SendMessageResult',
          messageId: 'mock-message-id-12345',
        },
      },
    },
  };
})();
